<template>
  <div class="m-grid__item m-grid__item--fluid d-flex justify-content-center">
    <div class="row m-0 w-75">
      <div class="col-12">
        <HeaderEmployee :nombre="nombre"></HeaderEmployee>
      </div>
      <transition name="fade">
        <MenuUserAM
          class="w-25"
          @companyCountry="companyCountry"
          @mailChanged="mailChanged"
          :hasChanged="hasChanged"
          @stateEmployee="stateEmployee"
          @hasOnboarding="hasOnboarding"
          :nombre="nombre"
          :fecha="fecha"
          :cuil="cuil"
          :rh="rh"
          @menuToSections="menuClick"
          :setTemplateChanged="setTemplateChanged"
          :resetData="templateChanged"
          @refreshInfoEmployee="refreshInfoEmployee"
          @userActiveOnb="userActiveOnb"
        >
        </MenuUserAM>
      </transition>
      <div class="w-75">
        <div class="" v-for="(section, index) in sectionsTitles" :key="index">
          <transition name="fade">
            <div v-if="section.id === 0 && section.show">
              <OnboardingEmployee
                :key="obeKey"
                @stateChanged="stateChanged"
                :employeeState="employeeState"
                :resetData="templateChanged"
                :setTemplateChanged="setTemplateChanged"
              ></OnboardingEmployee>
            </div>
          </transition>
          <transition name="fade">
            <div class="mr-3" v-if="section.id === 1 && section.show">
              <InfoEmployee
                :emailChange="emailChange"
                :country="country"
                :employeeState="employeeState"
                @childToParent="onChildClick"
                ref="infoEmployee"
              ></InfoEmployee>
            </div>
          </transition>
          <div v-if="section.id === 2 && section.show">
            <LicencesEmployee></LicencesEmployee>
          </div>
          <div v-if="section.id === 3 && section.show">
            <DocumentsEmployee></DocumentsEmployee>
          </div>
          <transition name="fade">
            <div v-if="section.id === 4 && section.show">
              <ConfigurationEmployee
                :employeeState="employeeState"
                :country="country"
                @rhChange="rhChange"
              ></ConfigurationEmployee>
            </div>
          </transition>
        </div>
        <PoliciesCompany></PoliciesCompany>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import Onboarding from "../../../apiClient/OnBoarding";
import Users from "../../../apiClient/User";
import Employee from "../../../apiClient/Employee";
import PoliciesCompany from "./PoliciesCompany";
import MenuUserAM from "./MenuUserAM.vue";
import InfoEmployee from "./InfoEmployee.vue";
import OnboardingEmployee from "./OnboardingEmployee.vue";
import LicencesEmployee from "./LicencesEmployee.vue";
import DocumentsEmployee from "./DocumentsEmployee.vue";
import ConfigurationEmployee from "./ConfigurationEmployee.vue";
import HeaderEmployee from "../useram/HeaderEmployee.vue";

export default {
  components: {
    Datepicker,
    PoliciesCompany,
    MenuUserAM,
    InfoEmployee,
    OnboardingEmployee,
    LicencesEmployee,
    DocumentsEmployee,
    ConfigurationEmployee,
    HeaderEmployee,
  },
  data() {
    return {
      Author: "ad89590098c7c6fbd7ad55aef965405e",
      sectionsTitles: [
        {
          id: 0,
          name: this.$t('message.employeePanel.sectionTitles.onboarding'),
          icon: "icon-Statics",
          show: false,
        },
        {
          id: 1,
          name: this.$t('message.employeePanel.sectionTitles.personalData'),
          icon: "icon-Person",
          show: false,
        },
        {
          id: 4,
          name: this.$t('message.employeePanel.sectionTitles.configuration'),
          icon: "icon-Config",
          show: false,
        },
      ],
      fecha: "",
      cuil: "",
      nombre: "",
      rh: null,
      employeeState: 0,
      hasChanged: "",
      country: "",
      emailChange: "",
      templateChanged: false,
      obeKey: 1,
      cachedEmployeeResponse: null,
    };
  },
  created() {
    this.ob = new Employee();
    this.op = new Onboarding();
    this.usersProfile = new Users();
    this.getUserInformation(this.$route.params.id);
  },
  mounted() {
  },
  methods: {
    setTemplateChanged(value) {
      this.templateChanged = value;
    },
    menuClick(sectionActive) {
      this.sectionsTitles = sectionActive;
    },
    refreshInfoEmployee(response) {
      this.cachedEmployeeResponse = response;
      this.$nextTick(() => {
        this.tryFillInfo();
      });
    },
    tryFillInfo() {
      if (this.cachedEmployeeResponse && this.$refs.infoEmployee) {
        let comp = Array.isArray(this.$refs.infoEmployee) ? this.$refs.infoEmployee[0] : this.$refs.infoEmployee;
        if (comp && typeof comp.fillInfo === 'function') {
          comp.fillInfo(this.cachedEmployeeResponse);
        }
      }
    },
    getUserInformation(id) {
      this.usersProfile
        .getinfoEmployee(id)
        .then((res) => {
          if (res.status === 200) {
            this.nombre = res.data.nombre + " " + res.data.apellido;
          }
        })
        .catch((error) => {});
    },
    onChildClick(value) {
      this.fecha = value.fecha;
      this.cuil = value.cuil;
      this.nombre = value.nombre + " " + value.apellido;
    },
    rhChange(value) {
      this.rh = value;
    },
    hasOnboarding(value) {
      this.employeeName = value;
    },
    stateEmployee(state) {
      this.employeeState = state;
      if (this.employeeState === 1) {
        this.sectionsTitles[1].show = true;
      }
      if (this.employeeState === 2) {
        this.sectionsTitles[0].show = true;
        this.sectionsTitles[1].show = false;
      }
      if (this.employeeState === 3) {
        this.sectionsTitles[1].show = true;
      }
      this.$nextTick(() => {
        this.tryFillInfo();
      });
    },
    stateChanged(state) {
      this.hasChanged = state;
    },
    companyCountry(country) {
      this.country = country;
    },
    mailChanged(mail) {
      this.emailChange = mail;
    },
    userActiveOnb() {
      this.obeKey++;
    },
  },
};
</script>
<style scoped lang="scss">
@import "./public/assets/scss/components/_usuarioam.scss";
</style>
